import {
	CupCalendarGameType,
	cupCalendarGameSchema,
} from "../schemas/cup_calendar";
import { CupInfoType, cupInfoSchema } from "../schemas/cup_info";
import { CupNewType, cupNewSchema } from "../schemas/cup_new";
import { cupNewsCardSchema, cupNewsCardType } from "../schemas/cup_news";
import {
	CupScoreTableType,
	cupScoreTableSchema,
} from "../schemas/cup_score_table";
import {
	dummy_cup_calendar_games,
	dummy_cup_info,
	dummy_cup_new,
	dummy_cup_news,
	dummy_cup_score_tables,
} from "../stores/cup_store/dummy_data";
import RESTService from "./rest_service";

export default abstract class CupService {
	public static async getCupCalendarGames(): Promise<CupCalendarGameType[]> {
		const requestedData = await RESTService.get(
			`/bitrix/services/main/ajax.php?action=module%3Aproject.iblock.calendargame`
		);
		//await RESTService.getDummy(dummy_cup_calendar_games);
		if (requestedData instanceof Array) {
			const games: CupCalendarGameType[] = [];
			(requestedData as Array<any>).forEach((game: any) => {
				const parsed = cupCalendarGameSchema.safeParse(game);
				if (parsed.success) games.push(parsed.data);
				else
					console.log(
						(game?.id ? "Game id: " + game.id + "\n\n" : "") +
							parsed.error
					);
			});
			return games.sort(
				(a: CupCalendarGameType, b: CupCalendarGameType) => {
					return (a.date?.year ?? 0) > (b.date?.year ?? 0) ? 1 : -1;
				}
			);
		}
		return [];
	}

	public static async getCupInfo(): Promise<CupInfoType | undefined> {
		const requestedData = await RESTService.get(
			`/bitrix/services/main/ajax.php?action=module%3Aproject.iblock.infobetcity`
		);
		//await RESTService.getDummy(dummy_cup_info);

		const parsed = cupInfoSchema.safeParse(requestedData);
		if (parsed.success) return parsed.data;
		else {
			console.log("CupInfo error: " + parsed.error);
			return undefined;
		}
	}

	public static async getCupNewsCards(): Promise<cupNewsCardType[]> {
		const requestedData = await RESTService.get(
			`/bitrix/services/main/ajax.php?action=module%3Aproject.iblock.newslist`
		);
		//await RESTService.getDummy(dummy_cup_news);
		if (requestedData instanceof Array) {
			const cards: cupNewsCardType[] = [];
			(requestedData as Array<any>).forEach((card: any) => {
				const parsed = cupNewsCardSchema.safeParse(card);
				if (parsed.success) cards.push(parsed.data);
				else
					console.log(
						(card?.id ? "News id: " + card.id + "\n\n" : "") +
							parsed.error
					);
			});
			return cards;
		}
		return [];
	}

	public static async getCupNew(id: number): Promise<CupNewType | undefined> {
		var body = new FormData();
		body.set("id", "" + id);
		const requestedData = await RESTService.post(
			`/bitrix/services/main/ajax.php?action=module%3Aproject.iblock.new`,
			body
		);
		//await RESTService.getDummy(dummy_cup_new);
		const parsed = cupNewSchema.safeParse(requestedData);
		if (parsed.success) return parsed.data;
		else {
			console.log("CupNew error: " + parsed.error);
			return undefined;
		}
	}

	public static async getCupScoreTables(): Promise<CupScoreTableType[]> {
		const requestedData = await RESTService.get(
			`/bitrix/services/main/ajax.php?action=module%3Aproject.iblock.tournament`
		);
		//await RESTService.getDummy(dummy_cup_score_tables);
		if (requestedData instanceof Array) {
			const tables: CupScoreTableType[] = [];
			(requestedData as Array<any>).forEach((table: any) => {
				const parsed = cupScoreTableSchema.safeParse(table);
				if (parsed.success) tables.push(parsed.data);
				else
					console.log(
						(table?.name
							? "Table name: " + table.name + "\n\n"
							: "") + parsed.error
					);
			});
			return tables;
		}
		return [];
	}
}
